$.fn.Drawer = function(options) {
  let self = this

  self.options = $.fn.extend({
    toggle: '.js-drawer-toggle',
    content: '.js-drawer-content',
  }, options)

  self.toggle = self.find(self.options.toggle)
  self.content = self.find(self.options.content)
  self.content.wrap('<div class="js-drawer-content-wrapper"></div>');
  self.contentWrapper = self.find('.js-drawer-content-wrapper')

  self.addClass('drawer')
  self.toggle.addClass('drawer__toggle')
  self.contentWrapper.addClass('drawer__content-wrapper')
  self.content.addClass('drawer__content')

  self.toggle.click(function() {
    if (!self.hasClass('--drawer-expanded')){
      $('.--drawer-expanded').removeClass('--drawer-expanded')
    }
    self.contentWrapper.css('--max-height', self.content.outerHeight() + 'px');
    self.toggleClass('--drawer-expanded');
    return false;
  })

  return function() {
    return self
  }()
}
